<div class="card mb-5 shadow-card">
  <div class="card-body studentticket-card-body">
    <div class="row g-0">
      <div class="accordion-container">
        <div class="accordion" [id]="'ticketAccordion-' + uniqueId">

          <!-- Ticket Panel -->
          <div class="accordion-item" data-cy="accordion-ticket-panel">
            <h2 class="accordion-header" [id]="'headingTicket-' + uniqueId">
              <button class="accordion-button" type="button" data-bs-toggle="collapse"
                      [attr.data-bs-target]="'#collapseTicket-' + uniqueId" aria-expanded="true"
                      [attr.aria-controls]="'collapseTicket-' + uniqueId" data-cy="accordion-ticket-button">
                <div class="accordion-header-custom">
                  <h3 class="accordion-title" data-cy="accordion-ticket-title">
                    {{ this.accordionTicketTitle }}
                  </h3>
                  <app-traffic-light-mini
                    class="accordion-traffic-light-mini"
                    [innerCircleColor]="getTicketStatusColor(this.ticket.status)">
                  </app-traffic-light-mini>
                </div>
              </button>
            </h2>
            <div [id]="'collapseTicket-' + uniqueId" class="accordion-collapse collapse show"
                 [attr.aria-labelledby]="'headingTicket-' + uniqueId" [attr.data-bs-parent]="'#ticketAccordion-' + uniqueId">
              <div class="accordion-body">
                <app-ticket-card-details
                  [ticket]="this.ticket"
                  [addressDataChangeEnabled]="addressDataChangeEnabled"
                  [schoolDataChangeEnabled]="schoolDataChangeEnabled"
                  (addressDetailsAdjust)="onaddressDetailsAdjust()"
                  (schoolDetailsAdjust)="onSchoolDetailsAdjust()"
                  (nameDetailsAdjust)="onNameDetailsAdjust()"
                  (emailDetailsAdjust)="onEmailDetailsAdjust()"
                  data-cy="ticket-card-details-child"
                ></app-ticket-card-details>
              </div>
            </div>
          </div>

          <!-- Payment Panel -->
          <div class="accordion-item" data-cy="accordion-zahlung-panel">
            <h2 class="accordion-header" [id]="'headingZahlung-' + uniqueId">
              <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse"
                      [attr.data-bs-target]="'#collapseZahlung-' + uniqueId" aria-expanded="false"
                      [attr.aria-controls]="'collapseZahlung-' + uniqueId" data-cy="accordion-zahlung-button">
                <div class="accordion-header-custom">
                  <h3 class="accordion-title" data-cy="accordion-zahlung-title">
                    {{ this.accordionZahlungTitle }}
                  </h3>
                  <app-traffic-light-mini
                    class="accordion-traffic-light-mini"
                    [innerCircleColor]="getPaymentStatusColor(this.ticket?.paymentInfo?.paymentStatus?.status)">
                  </app-traffic-light-mini>
                </div>
              </button>
            </h2>
            <div [id]="'collapseZahlung-' + uniqueId" class="accordion-collapse collapse"
                 [attr.aria-labelledby]="'headingZahlung-' + uniqueId" [attr.data-bs-parent]="'#ticketAccordion-' + uniqueId">
              <div class="accordion-body">
                <app-ticket-payment-details
                  [ticketPaymentInfo]="this.ticket?.paymentInfo"
                  [ticketMandateInformation]="this.ticket?.mandateHolder"
                  [geschwisterEigenanteilKomponenteEnabled]="this.geschwisterEigenanteilKomponenteEnabled"
                  (onMandateHolderInformationChange)="onMandateInformationChange()"
                  (onGeschwisterAdjust)="onGeschwisterAdjust()"
                  data-cy="ticket-payment-details-child"
                ></app-ticket-payment-details>
              </div>
            </div>
          </div>

          <!-- Termination Status Panel -->
          <div class="accordion-item" data-cy="accordion-status-panel">
            <h2 class="accordion-header" [id]="'headingStatus-' + uniqueId">
              <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse"
                      [attr.data-bs-target]="'#collapseStatus-' + uniqueId" aria-expanded="false"
                      [attr.aria-controls]="'collapseStatus-' + uniqueId" data-cy="accordion-status-button">
                <div class="accordion-header-custom">
                  <h3 class="accordion-title" data-cy="accordion-status-title">
                    {{ this.accordionStatusTitle }}
                  </h3>
                  <app-traffic-light-mini
                    class="accordion-traffic-light-mini"
                    [innerCircleColor]="getTerminationStatusColor(ticket.terminationStatus)">
                  </app-traffic-light-mini>
                </div>
              </button>
            </h2>
            <div [id]="'collapseStatus-' + uniqueId" class="accordion-collapse collapse"
                 [attr.aria-labelledby]="'headingStatus-' + uniqueId" [attr.data-bs-parent]="'#ticketAccordion-' + uniqueId">
              <div class="accordion-body">
                <app-ticket-termination-details
                  [ticket]="this.ticket"
                  (onTerminateTicket)="this.terminateTicket()"
                  (onCancelTicketTermination)="this.cancelTicketTermination()"
                  data-cy="ticket-termination-details-child"
                ></app-ticket-termination-details>
              </div>
            </div>
          </div>

          <!-- Verification Panel -->
          <div class="accordion-item" data-cy="accordion-ueberpruefung-panel">
            <h2 class="accordion-header" [id]="'headingVerification-' + uniqueId">
              <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse"
                      [attr.data-bs-target]="'#collapseVerification-' + uniqueId" aria-expanded="false"
                      [attr.aria-controls]="'collapseVerification-' + uniqueId" data-cy="accordion-ueberpruefung-button">
                <div class="accordion-header-custom">
                  <h3 class="accordion-title" data-cy="accordion-ueberpruefung-title">
                    {{ this.accordionUeberpruefungTitle }}
                  </h3>
                  <app-traffic-light-mini
                    class="accordion-traffic-light-mini"
                    [innerCircleColor]="getVerifiedStatusColor(lastVerifiedAt)">
                  </app-traffic-light-mini>
                </div>
              </button>
            </h2>
            <div [id]="'collapseVerification-' + uniqueId" class="accordion-collapse collapse"
                 [attr.aria-labelledby]="'headingVerification-' + uniqueId" [attr.data-bs-parent]="'#ticketAccordion-' + uniqueId">
              <div class="accordion-body">
                <div class="verification-content">
                  <p class="verification-text">{{ 'TICKETS.UEBERPRUEFUNG_CONFIRM_BUTTON' | translate }}</p>
                  <button class="btn btn-outline-primary w-100" data-cy="verify-ticket-button" (click)="openVerificationWizard()">
                    <span>{{ 'TICKETS.UEBERPRUEFUNG_CONFIRM_BUTTON_LABEL' | translate }}</span>
                  </button>
                  <p class="verification-hint" data-cy="verify-ticket-button-hint">{{ 'TICKETS.UEBERPRUEFUNG_CONFIRM_BUTTON_HINT' | translate }}</p>
                  @if(lastVerifiedAt) {
                    <div data-cy="verified-info" class="verified-info">
                      <p class="verified-date">
                        {{ 'TICKETS.UEBERPRUEFUNG_BESTAETIGT_AM' | translate }}
                        {{ lastVerifiedAt | date:'dd.MM.yyyy HH:mm' }}
                        {{ 'TICKETS.UEBERPRUEFUNG_UHR' | translate }}
                      </p>
                      <p class="verified-message">{{ 'TICKETS.UEBERPRUEFUNG_INFO_NACH_BESTAETIGUNG' | translate }}</p>
                    </div>
                  }
                </div>
              </div>
            </div>
          </div>

          <!-- Attachments Panel -->
          <div class="accordion-item" data-cy="accordion-anhaenge-panel">
            <h2 class="accordion-header" [id]="'headingAnhaenge-' + uniqueId">
              <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse"
                      [attr.data-bs-target]="'#collapseAnhaenge-' + uniqueId" aria-expanded="false"
                      [attr.aria-controls]="'collapseAnhaenge-' + uniqueId" data-cy="accordion-anhaenge-button">
                <div class="accordion-header-custom">
                  <h3 class="accordion-title" data-cy="accordion-anhaenge-title">
                    {{ this.accordionAnhaengeTitle }}
                  </h3>
                </div>
              </button>
            </h2>
            <div [id]="'collapseAnhaenge-' + uniqueId" class="accordion-collapse collapse"
                 [attr.aria-labelledby]="'headingAnhaenge-' + uniqueId" [attr.data-bs-parent]="'#ticketAccordion-' + uniqueId">
              <div class="accordion-body">
                <app-student-ticket-attachments
                  [ticketId]="this.ticket?.id"
                  data-cy="student-ticket-attachments-child"
                ></app-student-ticket-attachments>
              </div>
            </div>
          </div>

        </div>
      </div>
    </div>
  </div>
</div>


